import { apiUrl } from 'app/services/api.service';

export const DocumentService = {
  url: 'documents',

  getPolicyDownloadLink(quotationId: string): string {
    return `${apiUrl}${this.url}/policies/${quotationId}`;
  },

  getUserProfilePolicyDownloadLink(quotationId: string): string {
    return `${apiUrl}/car-insurances/quotations/${this.url}/policies/${quotationId}`;
  },

  getHiProDocumentDownloadLink(token: string, documentCode: string): string {
    return `${apiUrl}payments/hipro/documents/${token}/${documentCode}`;
  },
};
